import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaBarShapeOptions } from '../upp-konva-options';

/** Bar counter shape. */
export class UppKonvaBarShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'BAR' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaBarShapeOptions) {
        const { shape, stoolLeft, stoolRight, stoolFront, ...rest } = opts;
        const data: Record<string, unknown> = { shape };
        if (stoolLeft !== undefined) {
            data['stoolLeft'] = stoolLeft;
        }
        if (stoolRight !== undefined) {
            data['stoolRight'] = stoolRight;
        }
        if (stoolFront !== undefined) {
            data['stoolFront'] = stoolFront;
        }
        super({ ...rest, data });
    }
}
